import { render } from "./PriceListCompareDialog.vue?vue&type=template&id=58ac62fa&scoped=true"
import script from "./PriceListCompareDialog.vue?vue&type=script&lang=js"
export * from "./PriceListCompareDialog.vue?vue&type=script&lang=js"

import "./PriceListCompareDialog.vue?vue&type=style&index=0&id=58ac62fa&scoped=true&lang=css"
import "./PriceListCompareDialog.vue?vue&type=style&index=1&id=58ac62fa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ac62fa"]])

export default __exports__